import { alpha, Box, Card, Container, Grid, Stack, styled, Typography } from '@mui/material';
import { m } from 'framer-motion';
import React from 'react';
import { MotionViewport, varFade } from '../../components/animate';
import TextMaxLine from '../../components/TextMaxLine';

const Data = [
  {
    id: 1,
    title: "Identifier les opportunités adaptées à votre projet",
    image: '/assets/background/La_recherche_et_la_fourniture.jpg',
  },
  {
    id: 2,
    title: "L'assistance aux investisseurs pour l'obtention de permis et de licences nécessaires",
    image: '/assets/background/Licence_agreement.jpg',
  },
  {
    id: 3,
    title: 'Vous mettre en relation avec les administrations compétentes',
    image: '/assets/background/mise_en_relation.jpg',
  },
  {
    id: 4,
    title: "Vous accompagner dans la recherche d'un site d'implantation.",
    image: '/assets/background/recherche_de_terrains.jpg',
  },
];

const CardStyle = styled(Card)(({ url }) => ({
  border: 0,
  width: '100%',
  minHeight: 360,
  maxHeight: 360,
  margin: 'auto',
  backgroundImage: `url(${url})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
}));

const TextBackground = styled(Stack)(() => ({
  border: 0,
  width: '100%',
  height: '120px',
  background: 'rgba(10, 31, 22, 0.89)',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
}));

export default function HomeInvestCardList() {
  return (
    <Stack width={1}>
      <Stack width={1} bgcolor={(theme) => alpha(theme.palette.primary.main, 1)}>
        <Container>
          <Stack width={1} py={5} alignItems="center">
            <Typography variant="h3" maxWidth={{ xs: 1, md: 650 }} textAlign="center" color="common.white">
              Nous facilitons votre investissement
            </Typography>

            <Stack component={MotionViewport} direction={{ xs: 'column', md: 'row' }} py={{ xs: 2, md: 5 }}>
              <Grid container spacing={{ xs: 2, sm: 3, md: 5 }} justifyContent="center">
                {Data.map((_item) => (
                  <Grid component={m.div} variants={varFade().inUp} key={_item.id} item xs={12} sm={6} md={3}>
                    <CardItem title={_item.title} image={_item.image} />
                  </Grid>
                ))}
              </Grid>
            </Stack>
          </Stack>
        </Container>
      </Stack>
    </Stack>
  );
}

// Affiche une carte d'investissement avec image, overlay et titre centré
const CardItem = ({ image, title }) => {
  const [hover, setHover] = React.useState(false);

  return (
    <CardStyle url={image} onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
      <Stack height={360} justifyContent="flex-end">
        <Stack
          justifySelf="flex-end"
          justifyContent="space-between"
          sx={{ cursor: 'pointer', transition: 'height 0.5s ease-in-out' }}
        >
          <TextBackground
            p={2}
            spacing={2}
            sx={{ cursor: 'pointer', transition: 'height 0.5s ease-in-out', height: hover ? 200 : 120 }}
          >
            <Box height={7} width={60} bgcolor="warning.main" />
            <TextMaxLine line={3} variant="body2" fontSize={13} color="common.white" fontWeight="bold" sx={{ textAlign: 'center' }}>
              {title}
            </TextMaxLine>
          </TextBackground>
        </Stack>
      </Stack>
    </CardStyle>
  );
};
